// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2leX8","container":"LayoutSideNavigation_container__394LE","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2G-bX"};